import { ObjectiveMode } from '../../../__generated__/graphql';
import { useFlairLocalStorage } from '../../../hooks/useFlairLocalStorage';
import { useGoalsContext } from './GoalsContext/GoalsContext';
import { GoalViewBy, isGoalViewBy } from './types';

type StoredViewBy = GoalViewBy | null;

export const useGoalViewBy = (): [GoalViewBy, (value: GoalViewBy) => void] => {
  const { developmentFrameworkEnabled, objectiveMode, isManagerView } =
    useGoalsContext();
  const [stored, setStored] = useFlairLocalStorage('goals_view_by', null);

  const isMbo = objectiveMode === ObjectiveMode.Mbo;
  const storedOrNull: StoredViewBy = isGoalViewBy(stored) ? stored : null;
  const picked = pickDefaultViewBy(
    isManagerView,
    developmentFrameworkEnabled,
    storedOrNull,
  );
  const safed = getSafedViewBy(
    developmentFrameworkEnabled,
    isMbo,
    isManagerView,
    picked,
  );

  return [safed, setStored];
};

export function pickDefaultViewBy(
  isManagerView: boolean,
  developmentFrameworkEnabled: boolean,
  stored: StoredViewBy,
): GoalViewBy {
  if (stored != null) {
    return stored;
  }
  if (isManagerView && developmentFrameworkEnabled) {
    return GoalViewBy.EMPLOYEE;
  }
  return GoalViewBy.STATUS;
}

export function getSafedViewBy(
  developmentFrameworkEnabled: boolean,
  isMbo: boolean,
  isManagerView: boolean,
  viewBy: unknown,
): GoalViewBy {
  if (!isGoalViewBy(viewBy)) {
    return isMbo ? GoalViewBy.CATEGORY : GoalViewBy.STATUS;
  }
  if (viewBy === GoalViewBy.EMPLOYEE && !isManagerView) {
    return isMbo ? GoalViewBy.CATEGORY : GoalViewBy.STATUS;
  }
  if (isMbo && viewBy === GoalViewBy.STATUS) {
    return GoalViewBy.CATEGORY;
  }
  if (viewBy === GoalViewBy.CATEGORY && !developmentFrameworkEnabled) {
    return GoalViewBy.STATUS;
  }
  return viewBy;
}
